import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Text from '../Text/index.js';
const supportedSizes = [100, 200, 300, 400, 500, 600];
const getSize = size => {
  if (!supportedSizes.includes(size)) {
    return null;
  }
  if (size <= 400) {
    return size;
  }
  return {
    xs: size - 100,
    sm: size
  };
};

/**
 *  The Heading component takes children and wraps them in a container which utilizes the responsive text classNames
 *
 */
function SubHeading(_ref) {
  let {
    children,
    componentClass = 'div',
    size = [...supportedSizes].pop(),
    level,
    color,
    className,
    ...rest
  } = _ref;
  if (level) {
    return /*#__PURE__*/React.createElement(componentClass, {
      className: clsx({
        [`subheading-${level}`]: level,
        [`text-${color}`]: color && color !== 'default'
      }, className),
      'data-cmp': 'subheading',
      ...rest
    }, children);
  }
  return /*#__PURE__*/React.createElement(Text, Object.assign({
    "data-cmp": "subheading",
    size: getSize(parseInt(size, 10)),
    weight: "bold",
    componentClass: componentClass,
    className: className
  }, rest), children);
}
export default SubHeading;